<template> 
  <div>
    <div class="wz_viewportChats" v-if="numPlaceOccupe">
      <v-layout
        row
        wrap
        class="wz_viewportChat"
        :class="{
          'wz_attenteActif': listeAttente.length,
          'wz_attenteInactif': !listeAttente.length
        }"
      >
        <v-flex
          v-for="(pupitre, i) in pupitreViewsData"
          :key="i"
          class="fill-height pa-0"
          :class="{
            'viewSelected': placeFocus == (i + 1),
            'divisHauteur xs6': pupitreViewStatus == 4,
            'xs6': pupitreViewStatus == 2,
            'xs12': pupitreViewStatus == 1
          }"
          v-show="showingPupitre[i]"
        >
          <drop class="drop"
            @drop="data => handleDrop({
              dataDrop:data,
              statusView: pupitre.view.viewStatus,
              place: i + 1,
              idVisiteurPlace:pupitre.view.visiteurID,
              menuSelectedPlace:pupitre.view && pupitre.view.visiteurDatas ? pupitre.view.visiteurDatas.menuSelected : 'visitorCard',
              reponseCobrowsingPlace:pupitre.view && pupitre.view.visiteurDatas ? pupitre.view.visiteurDatas.reponseCobrowsing : false
            })"
            @dragover="data => handleDragStat({
              index:i,
              dataDrop:data,
              status: true
            })"
            @dragleave="data => handleDragStat({
              index:i,
              dataDrop:data,
              status: false
            })"
            :class="{ 'over': over[i] }"
          >
          <div class="wz_contentChatView" :class="{
            'view_border--bottom': pupitreViewStatus == 4 && (i == 0 || i == 1),
            'view_border--right': (pupitreViewStatus == 2 && i == 0) || (pupitreViewStatus == 4 && (i == 0 || i == 2))
          }">
              <wz-view-chat 
                :dragOverStatus="over[i]"
                :dragOverElement="elementsDrag"
                v-if="pupitre.view.viewStatus"
                :datasViewPupitre="pupitre.view"
                :placesPupitre="numPlaceOccupe"
                @supVisiteurFile="supVisiteurFileAttente"
                @click.native="focusView({'view': i + 1, 'visiteurID': pupitre.view.visiteurID})"
              ></wz-view-chat>
              <div 
                v-else
                class="bigNum"
              >
                <span>{{ i + 1}}</span>
              </div>
            </div>
          </drop>
        </v-flex>
      </v-layout>

      <wz-view-attente
        v-if="listeAttente.length > 0"
        :datasFileAttente="listeAttente"
        :pupitreData="pupitreViewsData"
        @supVisiteurFile="supVisiteurFileAttente"
        @click.native="focusView({'view': null, 'visiteurID': null})"
      ></wz-view-attente>

    </div>
    <!-- Aucun chat -->
    <v-card height="100%" v-else>
      <v-container fluid grid-list-lg>
        <!-- Si offline et pas de visiteur ciblé -->
        <v-alert
          outline
          color="secondary"
          icon="info"
          :value="!datasFilterVisiteursArray.length && status == 'offline'"
          transition="scale-transition"
        >
          {{ $t('noTargetingOffline') }}
        </v-alert>
        <v-layout row wrap>
          <v-flex xs12 md3>
            <v-img
              :src="domaine.indexOf('targetfirst') !== -1
                    ? `${domaine}/static/booster.png`
                    : `${domaine}/watcheezy/static/booster.png`"
              height="250px"
              contain
            ></v-img>
          </v-flex>
          <v-flex xs12 md7>
            <div>
              <section>
                <h2 class="headline accent--text">
                  <div>
                    <p>{{ $t('realTimeAnalysis') }}</p>
                  </div>
                </h2>
                <v-progress-linear color="accent" :indeterminate="true"></v-progress-linear>
                <blockquote class="blockquote secondary--text">
                  {{ $tc('targetedVisitors', datasFilterVisiteursArray.length, { count: datasFilterVisiteursArray.length }) | cap }}
                  {{ $t('outOf') }}
                  {{ $tc('visitors', listeAllVisiteurs.length, { count: nbVisitors }) }}
                </blockquote>
              </section>
              <div class="title text-xs-center">
              </div>
              <blockquote class="blockquote">
                <div v-html="$t('noIncomingChats') + ', ' + $t('checkActiveFilters')"></div>
              </blockquote>
              <v-btn
                v-if="checkPermission('NO_PEONS_NOR_AGENTS')"
                block
                :to="{path: '/target/filters'}"
                outline
                color="secondary"
              >
                <v-icon left>track_changes</v-icon>
                {{ $t('setUpFilters') }}
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>

    <!-- dialog multi connexion interrompue à distance -->
    <!-- cette dialogBox peut etre utiliser plus tard-->
    <v-dialog v-model="dialogChangeSlot" persistent max-width="290">
      <v-card>
        <v-card-title class="primary white--text subheading">{{ $t('changePlace') }}</v-card-title>
        <v-card-text
          v-if="dataEchangePlace"
          v-html="$t('changePlaceContent1') +' <b>'+ dataEchangePlace.place +'</b><br>'+ $t('changePlaceContent2') +' <b>'+ dataEchangePlace.idVisiteurPlace +'</b>.<br> '+ $t('askChangePlace') ">
        </v-card-text>
        <!-- $t('contentDialogSessionClose') -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click="dialogChangeSlot=false">{{$t('no')}}</v-btn>
          <v-btn class="blue--text darken-1" flat @click="echangePlace()">{{$t('yes')}}</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>
<script>
import { mapGetters, mapState, mapMutations } from 'vuex'
import _ from 'lodash'
import monitor from '../../mixins/monitor'
import { Drop } from 'vue-drag-drop'
import { DOMAINE } from '../../constants'
export default {
  mixins: [monitor],
  components: { Drop },
  data () {
    return {
      transfertActif: '',
      // la file d'attente
      fileAttente: [],
      arrayListeAttente: [],
      domaine: DOMAINE,
      over: [false, false, false, false],
      dialogChangeSlot: false,
      dataEchangePlace: null,
      elementsDrag: null
    }
  },

  watch: {
    // ----------------------------------------------------------------------------
    // Quand un visiteur repond/repond pas au questionnaire
    // ----------------------------------------------------------------------------
    'clientSatisfaction': function (val, oldval) {
      // Si le visiteur a répondu au questionnaire
      if (val.retour) {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: 'le visiteur ' + val.chatSession + ' a répondu à votre questionnaire de satisfaction', context: 'success' })
      } else { // sino il n'a pas répondu
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: 'le visiteur ' + val.chatSession + ' n\'a pas répondu à votre questionnaire de satisfaction', context: 'error' })
      }
    },

    // ajoute des infos visiteur en plus dans le pupitre
    // quant le monitor est passé
    'datasMonitorVisiteurs': function (val, oldval) {
      // console.log('pupitreViewsData : ', this.pupitreViewsData)
      _.forEach(this.pupitreViewsData, (VisiteurPupitre, key) => {
        // console.log('monitorVal', val)
        _.forEach(val, (monitorVal, key) => {
          // check dans le store quel visiteur est selectionné
          if (VisiteurPupitre.view.visiteurID === monitorVal.visiteurID) {
            let newDataVisiteur = _.cloneDeep(VisiteurPupitre.view.visiteurDatas)
            if (monitorVal.pagesFocus) {
              newDataVisiteur.pagesFocus = monitorVal.pagesFocus
            }
            this.SET_VISITEURS(newDataVisiteur)
          }
        })
      })
    }
  },
  mounted () {
  },

  methods: {
    ...mapMutations('_StoreWatcheeBox', [
      'SET_VISITEURS'
    ]),
    // ----------------------------------------------------------------------------
    // Au drop de l'element sur la pupitre
    // ----------------------------------------------------------------------------
    handleDrop (data) {
      if (data.dataDrop) {
        this.over = [false, false, false, false]
        console.log('You dropped with data:', data)
        // si la place est deja occupé
        if (data.statusView) {
          // si c'est pas la même place occupée pas ce visiteur
          if (data.place !== data.dataDrop.placePupitreActif) {
            // on echange les places
            this.dataEchangePlace = data
            this.echangePlace()
          }
        } else { // si c'est libre on change place le visiteur
          this.modifPlacePupitre(data)
        }
      }
    },

    handleDragStat (data) {
      // console.log('dragOver', data)
      // fonctionne uniquement si onglet dragé
      if (data.dataDrop) {
        if (data.status) {
          this.elementsDrag = data
        } else {
          this.elementsDrag = null
        }
        this.over.splice(data.index, 1, data.status) // change l'etat du over sur le drop
      }
    },

    // ----------------------------------------------------------------------------
    // retour 'oui' de la dialogBox pour echanger les places visiteurs
    // ----------------------------------------------------------------------------
    echangePlace () {
      this.modifPlacePupitre(this.dataEchangePlace)
      this.dialogChangeSlot = false
    },

    // ----------------------------------------------------------------------------
    // Change la place du visiteur dans le pupitre
    // ----------------------------------------------------------------------------
    modifPlacePupitre (data) {
      this.$store.commit('_StoreWatcheeBox/CHANGE_PLACE_PUPITRE_VISITEUR', data)
      this.dataEchangePlace = null
    },

    // ----------------------------------------------------------------------------
    // Supprime le visiteur de la file d'attente
    // ----------------------------------------------------------------------------
    supVisiteurFileAttente (visiteurID) {
      console.log('supVisiteurFileAttente', visiteurID)
      // Remove la sesion privée
      var indexSession = _.findIndex(this.sessionsPrivees, [1, visiteurID])
      this.$store.commit('_StoreWatcheeBox/REMOVE_PRIVATE_SESSION_CHAT',
        {
          index: indexSession,
          visiteurID: visiteurID
        }
      )
    },

    // ----------------------------------------------------------------------------
    // Supprime le visiteur du pupitre
    // ----------------------------------------------------------------------------
    supVisiteur (visiteurID) {
      console.log('supVisiteur', visiteurID)
      // Remove la sesion privée
      var indexSession = _.findIndex(this.sessionsPrivees, [1, visiteurID])
      var indexVisiteur = _.findIndex(this.listeAllVisiteurs, {'visiteurID': visiteurID})
      let placeDispo = 0
      // visiteur sur le pupitre
      if (this.listeAllVisiteurs[indexVisiteur].placePupitre !== null) {
        placeDispo = this.listeAllVisiteurs[indexVisiteur].placePupitre
      }
      this.$store.commit('_StoreWatcheeBox/REMOVE_PRIVATE_SESSION_CHAT',
        {
          index: indexSession,
          visiteurID: visiteurID,
          placePupitre: placeDispo
        }
      )
    },

    // ----------------------------------------------------------------------------
    // Fermeture de la fenetre de chat du pupitre apres le transfere
    // ----------------------------------------------------------------------------
    closeChatTransfere: function (visiteurID) {
      // console.log('closeChatTransfere', visiteurID)
      // Création d'un nouveau tableau arrayvisteur pour mettre à jours le store visteur
      var arrayVisiteur = [] // nouveau tableau visiteur
      for (var a = 0; a < this.listeAllVisiteurs.length; a++) {
        // check dans le store quel visiteur doit etre mise a jour
        if (this.listeAllVisiteurs[a].visiteurID === visiteurID) {
          arrayVisiteur = _.cloneDeep(this.listeAllVisiteurs[a]) // clone le visiteur
          // retire la place qu'il occupait sur le pupitre
          arrayVisiteur.placePupitre = ''
          // arrayVisiteur.splice(7, 1)
        }
      }
      // Mise à jour du tableau 'pupitreViewsData' de la vue 'chatting.vue'
      // regarde dans le pupitre a quelle place ce trouve ce visiteur
      for (var c = 0; c < this.pupitreViewsData.length; c++) {
        if (this.pupitreViewsData[c].view.visiteurID === visiteurID) { // si view est utilisé par ce visiteur
          // this.pupitreViewsData[c].view.visiteurID = '' // retire l'id visiteur dans la vue pupitre
          // this.pupitreViewsData[c].view.viewStatus = false // affiche la vue pupitre (la place est libre maintenant)
          this.remplaceVisiteur(
            {
              'placeDispo': c,
              'ancienVisiteurID': visiteurID
            }
          ) // la place est libre on regarde si il n'y a pas un visteur en liste d'attente pour prendre la place
          break
        }
      }
      // Mise à jour du store visiteur
      this.SET_VISITEURS(arrayVisiteur)
      this.$store.dispatch('_Notifier/NEW_NOTIF',
        {
          message: 'Formulaire de satisfaction envoyé au visiteur ' + visiteurID,
          context: 'success'
        }
      )
    }
  },

  computed: {
    ...mapState('_StoreWatcheeBox', ['listeAllVisiteurs', 'newMessage', 'clientSatisfaction', 'sessionsPrivees', 'mySocketID', 'status', 'focusPupitre', 'pupitreViewStatus']),
    ...mapGetters('_StoreWatcheeBox', ['WATCHEEBOX_STATE', 'pupitreViewsData']),
    ...mapGetters('_User', ['user']),

    numPlaceOccupe () {
      let slots = this.pupitreViewsData.filter(p => p.view.viewStatus)
      return slots && slots.length
    },

    listeAttente () {
      // si il y a plus de chat que de place sur le pupitre
      // vide le tableau
      this.arrayListeAttente = []
      // clone le tableau pupitreView
      let newArrayPupitre = _.cloneDeep(this.pupitreViewsData)
      // console.log('newArrayPupitre : ', newArrayPupitre)
      // retire de la liste le nombre de place pupitre depuis le debut
      newArrayPupitre.splice(0, this.pupitreViewStatus)
      // console.log('newArrayPupitre : ', newArrayPupitre)
      _.forEach(newArrayPupitre, (placesPupitre, key) => {
        // si c'ette place est occupée
        if (placesPupitre.view.viewStatus) {
          // console.log('this.arrayListeAttente', this.arrayListeAttente)
          // placesPupitre.view.visiteurDatas.timeStampArrive = Date.now()
          this.arrayListeAttente.push(_.cloneDeep(placesPupitre.view.visiteurDatas))
          // this.arrayListeAttente[key].timeStampArrive = Date.now()
          // console.log('_self.arrayListeAttente.length', this.arrayListeAttente.length)
          // retire de la liste le nombre de place pupitre depuis le debut
          // _self.arrayListeAttente.splice(0, this.pupitreViewStatus)
        }
      })
      // retourne la liste d'attente visiteur
      return this.arrayListeAttente
    },

    placeFocus () {
      return this.focusPupitre.view
    },

    nbVisitors () {
      return this.$store.state._StoreWatcheeBox.listeAllVisiteurs.length > 99
        ? '99+'
        : this.$store.state._StoreWatcheeBox.listeAllVisiteurs.length
    },
    // dataVisiteurComputed () {
      // console.log('this.concatAllVisiteurs', this.concatAllVisiteurs)
      // var visteurDataSelected = _.find(this.concatAllVisiteurs, {'visiteurID': this.visSelected})
      // return {'cobrowsing': this.iframeStatus, 'online': true, 'viewStatus': true, 'visiteurDatas': visteurDataSelected, 'visiteurID': this.visSelected}
    // },
    showingPupitre () {
      return [
        true,
        this.pupitreViewStatus !== 1,
        this.pupitreViewStatus !== 2 && this.pupitreViewStatus !== 1,
        this.pupitreViewStatus !== 2 && this.pupitreViewStatus !== 1
      ]
    }
  },

  beforeDestroy () {
    this.stopMonitor()
  }

}
</script>

<style>
.bigNum {
  text-align: center;
  position: relative;
  top: calc(50% - 100px);
  margin: 0px;
}
.bigNum span{
  font-size:  150px;
  color: rgba(0, 0, 0, 0.1);
  pointer-events: none;
  -moz-user-select: none; /* Firefox */
  -webkit-user-select: none; /* Chrome, Safari, Opéra depuis la version 15 */
  -ms-user-select: none; /* Internet explorer depuis la version 10 et Edge */
  user-select: none; /* Propriété standard */
}
.wz_viewportChats{
  height: calc(100vh - 102px);
}
.wz_viewportChat{
  padding-bottom: 4px; 
}
.wz_attenteInactif{
  height: calc(100vh - 112px);
}
.wz_attenteActif{
  height: calc(100vh - 152px);
}
.wz_contentChatView{
  background-color: #eee;
  height:100%;
}
.wz_attenteInactif .divisHauteur{
  height: calc(50vh - 56px);
}
.wz_attenteActif .divisHauteur{
  height: calc(50vh - 80px);
}
.drop {
  height: 100%;
}
.drop.over {
  border: 4px solid #999;
  border-style: dashed;
}
.view_border--top {
  border-top: 2px solid #1961AC;
}
.view_border--bottom {
  border-bottom: 2px solid #1961AC;
}
.view_border--left {
  border-left: 2px solid #1961AC;
}
.view_border--right {
  border-right: 2px solid #1961AC;
}
</style>



// WEBPACK FOOTER //
// src/components/trafic/Chatting.vue